import { render, staticRenderFns } from "./8d1cc434-19b5-4261-8b5c-26b29d3f7581.vue?vue&type=template&id=2f2f45d3&scoped=true"
import script from "./8d1cc434-19b5-4261-8b5c-26b29d3f7581.vue?vue&type=script&lang=ts"
export * from "./8d1cc434-19b5-4261-8b5c-26b29d3f7581.vue?vue&type=script&lang=ts"
import style0 from "./8d1cc434-19b5-4261-8b5c-26b29d3f7581.vue?vue&type=style&index=0&id=2f2f45d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f45d3",
  null
  
)

export default component.exports